import i18next from 'i18next';
import ar from './navigation-i18n/ar';
import en from './navigation-i18n/en';
import tr from './navigation-i18n/tr';

i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('tr', 'navigation', tr);
i18next.addResourceBundle('ar', 'navigation', ar);

const navigationConfig = [
  {
    id: 'dashboard.main',
    title: 'Panel principal',
    type: 'item',
    icon: 'material-solid:widgets',
    // icon: 'material-outline:grid_view',
    url: 'dashboard',
  },
  {
    id: 'dashboardsGroup.scope_none',
    type: 'divider',
  },
  {
    id: 'transactionsGroup',
    title: 'Transacciones',
    subtitle: 'Plataformas de pago y facturacion',
    type: 'group',
    children: [
      {
        id: 'billingGroup',
        title: 'Facturación',
        type: 'collapse',
        icon: 'material-outline:price_check',
        children: [
          {
            id: 'billingGroup.dashboard',
            title: 'Dashboard',
            type: 'item',
            icon: 'material-outline:grid_view',
            url: '/billing/dashboard',
          },
          {
            id: 'billingGroup.bills',
            title: 'Facturas',
            type: 'item',
            icon: 'material-outline:library_books',
            url: '/billing/bills',
          },
          {
            id: 'billingGroup.reports',
            title: 'Reportes',
            type: 'item',
            icon: 'material-outline:library_books',
            url: '/billing/reports',
          },
          {
            id: 'billingGroup.configuration',
            title: 'Configuración',
            type: 'item',
            icon: 'heroicons-outline:cog',
            url: '/billing/configuration',
          },
        ],
      },
      {
        id: 'openPayGroup',
        title: 'OpenPay',
        type: 'collapse',
        icon: 'material-outline:payments',
        children: [
          {
            id: 'openPayGroup.dashboard',
            title: 'Panel',
            type: 'item',
            icon: 'material-outline:payments',
            url: 'open-pay/dashboard',
          },
          {
            id: 'openPayGroup.payments',
            title: 'Pagos',
            type: 'item',
            icon: 'material-outline:payments',
            url: 'open-pay/payments',
          },
          {
            id: 'openPayGroup.suscriptions',
            title: 'Suscripciones',
            type: 'item',
            icon: 'material-outline:payments',
            url: 'open-pay/suscriptions',
          },
          {
            id: 'openPayGroup.plans',
            title: 'Planes / Precios',
            type: 'item',
            icon: 'material-outline:payments',
            url: 'open-pay/plans',
          },
          {
            id: 'openPayGroup.events',
            title: 'Eventos',
            type: 'item',
            icon: 'material-outline:payments',
            url: 'open-pay/events',
          },
          {
            id: 'openPayGroup.configuration',
            title: 'Configuración',
            type: 'item',
            icon: 'heroicons-outline:cog',
            url: 'open-pay/configuration',
          },
        ],
      },
      {
        id: 'dashboardsGroup.scope_none',
        type: 'divider',
      },
    ],
  },
  {
    id: 'companiesGroup.main',
    title: 'Compañías',
    type: 'item',
    icon: 'material-outline:domain',
    url: 'companies',
  },
  {
    id: 'locationsGroup.main',
    title: 'Locaciones',
    type: 'item',
    icon: 'material-outline:maps_home_work',
    url: '/locations',
  },
  {
    id: 'terminalsGroup',
    bypass: true,
    title: 'Terminales',
    subtitle: 'Información de terminales disponibles',
    type: 'group',
    children: [
      {
        id: 'kiosksGroup',
        title: 'Kioscos',
        type: 'collapse',
        icon: 'material-outline:system_security_update',
        children: [
          {
            id: 'kiosksGroup.dashboard',
            title: 'Dashboard',
            type: 'item',
            icon: 'material-outline:grid_view',
            url: 'kiosks/dashboard',
          },
          {
            id: 'kiosksGroup.terminals',
            title: 'Terminales',
            type: 'item',
            icon: 'material-outline:perm_device_information',
            url: 'kiosks',
          },
        ],
      },
      {
        id: 'turnstilesGroup',
        title: 'Torniquetes',
        type: 'collapse',
        icon: 'material-outline:device_hub',
        children: [
          {
            id: 'turnstilesGroup.dashboard',
            title: 'Dashboard',
            type: 'item',
            icon: 'material-outline:grid_view',
            url: 'turnstiles/dashboard',
          },
          {
            id: 'turnstilesGroup.terminals',
            title: 'Terminales',
            type: 'item',
            icon: 'material-outline:perm_device_information',
            url: 'turnstiles',
          },
        ],
      },
      {
        id: 'userRegistersGroup',
        title: 'Puntos de registro',
        type: 'collapse',
        icon: 'material-outline:desktop_mac',
        children: [
          {
            id: 'userRegistersGroup.dashboard',
            title: 'Dashboard',
            type: 'item',
            icon: 'material-outline:grid_view',
            url: 'user-registers/dashboard',
          },
          {
            id: 'userRegistersGroup.terminals',
            title: 'Terminales',
            type: 'item',
            icon: 'material-outline:perm_device_information',
            url: 'user-registers',
          },
        ],
      },
      {
        id: 'recognitionGroup',
        title: 'Reconocimiento',
        type: 'collapse',
        icon: 'material-outline:portrait',
        children: [
          {
            id: 'recognitionGroup.dashboard',
            title: 'Dashboard',
            type: 'item',
            icon: 'material-outline:grid_view',
            url: 'recognition/dashboard',
          },
          {
            id: 'recognitionGroup.terminals',
            title: 'Terminales',
            type: 'item',
            icon: 'material-outline:perm_device_information',
            url: 'recognition',
          },
        ],
      },
      {
        id: 'terminalsGroup.divider',
        type: 'divider',
      },
    ],
  },
  {
    id: 'adminGroup',
    title: 'Config. de administrador',
    subtitle: 'Información general para administradores',
    type: 'group',
    children: [
      {
        id: 'adminGroup.access',
        title: 'Administradores',
        type: 'item',
        icon: 'material-outline:admin_panel_settings',
        url: '/admin',
      },
    ],
  },
];

export default navigationConfig;
